import type { InboxHooks, InboxPlatformConfig, InboxStore } from '../types';
import { GenericConversationList } from '../GenericConversationList';
import { GenericChatView } from '../GenericChatView';
import { GenericAgentConfigPanel } from '../GenericAgentConfigPanel';
import styles from './InboxLayout.module.css';

interface Props {
    hooks: InboxHooks;
    store: InboxStore;
    platform: InboxPlatformConfig;
}

export function InboxLayout({ hooks, store, platform }: Props) {
    const { selectedConversationId } = store;

    return (
        <div className={styles.container}>
            <div className={`${styles.sidebar} ${selectedConversationId ? styles.hideMobile : ''}`}>
                <GenericConversationList hooks={hooks} store={store} platform={platform} />
            </div>
            <div className={`${styles.main} ${!selectedConversationId ? styles.hideMobile : ''}`}>
                <GenericChatView hooks={hooks} store={store} platform={platform} />
            </div>
            <GenericAgentConfigPanel hooks={hooks} store={store} platform={platform} />
        </div>
    );
}
